<template>
  <section>
    <one-line-form :submit="updateOpenQuestion" :submittable="!!openQuestion && isValid && !duplicated" :saving="isSaving ? openQuestion : ''">
      <input-field name="openQuestion"
                   :class="{ invisible: isSaving }"
                   type="text"
                   :maxlength="(screenParams.maxlength && screenParams.maxlength.toString()) || ''"
                   :title="screenParams.title()"
                   :placeholder="screenParams.placeholder()"
                   :autocapitalize="true"
                   :autocorrect="false"
                   :value="openQuestion"
                   @input="syncOpenQuestion" />
    </one-line-form>
    <helper v-if="duplicated && !isSaving" :error="true" class="warningHint">{{ screenParams.duplicated() }}</helper>
    <helper v-if="!duplicated && screenParams.description">
      <p v-show="!isSaving">{{ screenParams.description($store) }}</p>
    </helper>
    <show-keyboard></show-keyboard>
  </section>
</template>

<style>
  .hidden-input {
    top: -1000px;
    position: absolute;
  }
  .warningHint {
    margin-bottom: 10px;
  }
</style>

<script>
  import Vue from 'vue'
  import { isValid as isValidEmail } from '../utils/email'
  import config from '../partners/partner.module.config'

  export default Vue.component('open-question-screen', {
    props: ['screenParams'],
    data () {
      return {
        openQuestion: this.screenParams.currentAnswer(this.$store) || '',
        isSaving: false
      }
    },
    computed: {
      isValid () {
        if(this.screenParams.minLength && this.openQuestion?.length < this.screenParams.minLength) {
          return false
        }
        else if (!this.screenParams.validation) {
          return true
        } else {
          switch (this.screenParams.validation.type) {
            case 'email' :
              return isValidEmail(this.openQuestion)
            case 'phone' :
              return this.validatePhone(this.openQuestion)
            case 'fullName' :
              return this.validateFullName(this.openQuestion)
            case 'maidenName' :
              return this.validateMaidenName(this.openQuestion)
            default:
              return true
          }
        }
      },
      duplicated () {
        if (this.screenParams.validation && this.screenParams.validation.duplicateCheck) {
          const originalValue = this.retrieveValue(this.screenParams.validation.duplicateValue, this.$store.state)
          return this.openQuestion && originalValue && originalValue === this.openQuestion
        } else {
          return false
        }
      }
    },
    methods: {
      validateFullName (name) {
        let splitFullname = name.split(' ')
        return (splitFullname.length >= 2 && !!splitFullname[1])
      },
      validatePhone (phone) {
        return /^\d{5,}$/.test(phone)
      },
      syncOpenQuestion (value) {
        if (this.usingPrefill && value !== this.openQuestion) this.usingPrefill = false
        this.openQuestion = value
      },
      updateOpenQuestion () {
        if (this.openQuestion) {
          this.isSaving = true
          let answerData = {}
          answerData[this.screenParams.propertyName] = this.openQuestion
          this.$store.dispatch(this.screenParams.dispatchKey, answerData)
          this.$store.dispatch('next', this.screenParams.nextScreenRoute)
        }
      },
      retrieveValue (path, obj, separator = '.') {
        const properties = Array.isArray(path) ? path : path.split(separator)
        return properties.reduce((prev, curr) => prev && prev[curr], obj)
      },
      validateMaidenName (name) {
        const {maidenNameRegExp} = config.settings.customRegex;
        return new RegExp(maidenNameRegExp).test(name)
      }
    }
  })
</script>



// WEBPACK FOOTER //
// src/screens/OpenQuestion.vue